export let FilterType = /*#__PURE__*/function (FilterType) {
  FilterType[FilterType["CHECKBOX"] = 0] = "CHECKBOX";
  FilterType[FilterType["COLOR_CIRCLES"] = 1] = "COLOR_CIRCLES";
  FilterType[FilterType["PRICE_RANGE"] = 2] = "PRICE_RANGE";
  FilterType[FilterType["RADIOBUTTON"] = 3] = "RADIOBUTTON";
  FilterType[FilterType["BOX_AND_INVENTORY"] = 4] = "BOX_AND_INVENTORY";
  return FilterType;
}({});